/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Law_H2Inputs */

const es_l7_law_h2 = /** @type {(inputs: L7_Law_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La ley que cambia las reglas para tu barco.`)
};

const gl_l7_law_h2 = /** @type {(inputs: L7_Law_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A lei que cambia as regras para o teu barco.`)
};

const en_l7_law_h2 = /** @type {(inputs: L7_Law_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The law that changes the rules for your boat.`)
};

/**
* | output |
* | --- |
* | "The law that changes the rules for your boat." |
*
* @param {L7_Law_H2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_law_h2 = /** @type {((inputs?: L7_Law_H2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Law_H2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_law_h2(inputs)
	if (locale === "en") return en_l7_law_h2(inputs)
	return es_l7_law_h2(inputs)
});